<template>
     <vs-dialog @close="handleClose" v-model="active">
        <template #header>
          <h4 class="not-margin">
            Aplicar descuentos
          </h4>
        </template>
          <div class="con-form">
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" w="12" lg="6">
                <label for="programa"  class="labelInput">
                  Programa 
                </label>
                <vs-select class="pt-0" :filter="Boolean(listPrograma.length > 1)" id="programa" v-model="programa" :key="programaId" :disabled="Boolean(errorMensaje) || !Boolean(listPrograma.length > 1) " ref="content"  >
                  <template #message-danger v-if="errorFields.includes('programa')">
                      Requerido
                  </template>
                  <template v-if="listPrograma.length">
                      <vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
                          {{option.text}}
                      </vs-option>
                  </template>
                  <template v-else>
                      <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                      </vs-option>
                  </template>
              </vs-select>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" w="12" lg="6">
                <label for="fecha"  class="labelInput">
                  Fecha 
                </label>
                <vs-input
                  type="date"
                  v-model="fecha"
                  required="required"
                  id="fecha"
                  name="fecha"
                  class="pt-0"
                  :disabled="Boolean(errorMensaje)">
                  <template #message-danger v-if="errorFields.includes('fecha')">
                      Requerido
                  </template>
                </vs-input>
              </vs-col>
            </vs-row>
            <vs-row v-if="!errorMensaje">
              <vs-col vs-justify="center" vs-align="center" w="12" lg="6">
                <vs-select v-if="!listConceptos.length > 1" filter label-placeholder="Concepto"   v-model="concepto"  :key="conceptoId">
                  <template v-if="listConceptos.length">
                    <vs-option v-for="option in listConceptos" :key="option.id" :label="option.concepto" :value="option.concepto">
                      {{option.concepto}}
                    </vs-option>
                  </template>
                  <template v-else>
                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                    </vs-option>
                  </template>
                </vs-select>
                <div>
                  <label for="programa"  class="labelInput">
                    Concepto 
                  </label>
                  <p style="padding: 0px 10px 10px 10px" v-for="option in listConceptos" :key="option.id">{{option.concepto}}</p>
                </div>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" w="12" lg="6">
                <label for="monto" class="labelInput">
                  Monto
                </label>
                <!-- <h3 v-if="!listConceptos.length > 1">{{monto}}</h3>
                <h5 v-else style="padding: 0px 10px 10px 10px" v-for="option in listConceptos" :key="option.id">{{option.total}}</h5> -->
                <vs-input
                  type="number"
                  v-model="monto"
                  required="required"
                  id="monto"
                  step="0.01"
                  min="1"
                  name="monto"
                  style="padding: 0px 10px 10px 10px">
                  <template #message-danger v-if="errorFields.includes('monto')">
                      Requerido
                  </template>
                </vs-input>
              </vs-col>
              <!-- <vs-col vs-justify="center" vs-align="center" w="12" lg="6"> -->
                <!-- <div style="padding: 0px 10px 10px 10px" v-for="option in listConceptos" :key="option.id">
                  <label class="labelInput">
                    <span v-if="option.porcentaje !== null">Porcentaje</span>
                    <span v-else>Monto</span>
                  </label>
                  <h5 v-if="option.porcentaje !== null" class="text-center">{{option.porcentaje}}</h5>
                  <h5 v-else class="text-center">{{option.monto}}</h5>
                </div> -->
                <!-- <vs-input
                  type="number"
                  v-model="monto"
                  required="required"
                  id="monto"
                  step="0.01"
                  min="1"
                  name="monto">
                  <template #message-danger v-if="errorFields.includes('monto')">
                      Requerido
                  </template>
                </vs-input>
              </vs-col> -->
            </vs-row>
            <vs-row v-else>
              <span style="color: red; padding-left: 10px"><strong>{{errorMensaje}}</strong></span>
            </vs-row>
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" w="12">
                <md-field>
                  <label>Comentarios</label>
                  <md-textarea
                    v-model="comentarios"
                    id="comentarios"
                    name="comentarios"
                    :disabled="Boolean(errorMensaje)">
                  </md-textarea>
                </md-field>
              </vs-col>
            </vs-row>
          </div>
          <template #footer>
            <div class="footer-dialog">
              <vs-button :disabled="Boolean(errorMensaje)" block class="color-blue" @click="aplicarDescuento">
                Guardar
              </vs-button>           
            </div>
          </template>
        
      </vs-dialog>
</template>

<script>
import cobranza from '../../../../../api/requests/cobranza-persona.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
      'nivel',
      'nivelId',
      'listNivel',
      'programaId',
      'listPrograma',
      'programaDefault',
      'conceptoDescuentos'
    ],
    data () {
        return {
            active: false,
            fecha: null,
            monto: null,
            comentarios: null,
            errorFields: [],
			      conceptoId: (new Date()).getTime(),
            programa: '',
            concepto: '',
			      listConceptos: [],
            errorMensaje: '',
            total: ''
        }
    },
    mounted(){
     // invocar los métodos
     this.aplicarDescuentoConceptos()
    },
    methods: {
      openLoading() {
        const loading = this.$vs.loading({
          target: this.$refs.content
        })
        setTimeout(() => {
          loading.close()
        }, 3000)
      },
      async aplicarDescuento() {         
        this.errorFields = this.sanityForm ()
            if (!this.errorFields.length) {  
              let loading = this.$vs.loading()
              try {
                const data = {
                    ciclo_escolar: this.cicloEscolar,
                    institucion: this.institucion,
                    programa: this.programa,
                    id: this.personaId,
                    fecha: this.fecha,
                    monto: this.monto,
                    comentarios: this.comentarios,
                    cargo: this.row.id,
                  }
          
                const response = await cobranza.getGetDescuento(data)
                if(response.data.response[0].status){
                  loading.close()
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'success',
                      position: null,
                      title: 'Operación éxitosa'
                  })
                  this.$emit('refreshTable',true)
                } else {
                  loading.close()
                }

                this.fecha = null
                this.monto = null
                this.comentarios = null 
                this.active = false
              } catch(error) {
                  loading.close()
                  const response = error.response.data
                  if (response && response.errores){
      			        const data = response.errores
				            let mensajes = Object.values(data)
                    if (Array.isArray(mensajes)){
                      mensajes.forEach(element => {
                        if ( this.checkByType('string', element)){
                          this.$vs.notification({
                            duration: 5000,
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element 
                          })
                        }
                      });
                    }else if (mensajes.descripcion && this.checkByType('string', mensajes)){
                      this.$vs.notification({
                          duration: 5000,
                          progress: 'auto',
                          color: 'danger',
                          position: null,
                          title: 'Error',
                          text: mensajes.descripcion 
                      })
					
                      }else {
                          this.$vs.notification({
                            progress: 'auto',
                            duration: 5000,
                            color: 'warn',
                            position: null,
                            title: 'Warning',
                            text: `Algo salió mal pero es posible que se haya registrado tu pago`
                          })
                      }
      		      }
              }  
            }     
      },
      async aplicarDescuentoConceptos() {
        if(this.row.id !== '')  {
          try {
            const data = {
                'id': this.personaId,
                'cargo': this.row.id,
              }
            const response = await cobranza.getGetDescuentoConceptos(data)
            this.listConceptos = response.data.descuentos
      	    this.conceptoId = (new Date()).getTime()
            // this.getMonto()
          } catch(error) {
            this.errorMensaje = error.response.data.errores.descripcion
          }
        }
      },
      getMonto() {
        const monto = this.listConceptos
        monto.forEach(i => {
          if(i.concepto === this.concepto){
            this.monto = i.total
          }else{
            this.monto = i.total
          }
        })
      },
      checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'date':
                    if (val && val.constructor.name === 'Date' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
      },
      sanityForm () {
            let errorFields = []
            if (!this.checkByType ('string', this.fecha)) {
                errorFields.push('fecha')
            }
            // if (!this.checkByType ('number', parseInt(this.monto))) {
            //     errorFields.push('monto')
            // }
            
            return errorFields
      },
      handleClose(){
        this.concepto= '',
        this.active= false,
        this.fecha = null,
        this.monto = null,
        this.comentarios= null
      }
    },
    watch: {
        async programaDefault(){
		      this.programa = this.programaDefault
	      },
        value (val) {
            this.active = val
            this.aplicarDescuento()
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(val){
          this.aplicarDescuentoConceptos()
        },
        // concepto(val){
        //   this.getMonto()
        // }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>

<style>
.labelInput{
	margin-bottom: 6px !important;
	padding: 0px 11px 0px 11px;
	font-size: 12px;
}
</style>